export default __webpack_public_path__ + "static/media/newBackground.c34feba9.png";